import * as React from 'react';
import moment from 'moment';

import { ICalendarState, IMonth } from '../classes/calendar';

import { connect } from 'react-redux';

import { ICalendarAppState } from '../redux-state';

import { scrollToMonth } from '../../calendar/helpers/scroll-to-month';
import { ICalendarAppText } from '../redux-state/interfaces/text/calendar-app.text';
import { CalendarDeviceMode, CalendarViewMode } from '../redux-state/interfaces/calendar-settings';
import { setToGrid, setToList } from '../redux-state/actions/calendar-settings.actions';
import CalendarModeToggleView from './calendar-view-toggle.view';

interface ICalendarViewTogglePropsExternalProps {

}

interface StateToProps {
    text: ICalendarAppText
    calendarMode: CalendarViewMode;
    calendarDeviceMode: CalendarDeviceMode;
    currentDate: moment.Moment;
    startMonth: moment.Moment;
}

interface DispatchToProps {
    setToGrid: (currentDate?: moment.Moment, startDate?: moment.Moment) => void;
    setToList: (currentDate?: moment.Moment, startDate?: moment.Moment) => void;
}

export type CalendarViewToggleProps = ICalendarViewTogglePropsExternalProps & StateToProps & DispatchToProps;

export class CalendarViewToggleBase extends React.Component<CalendarViewToggleProps, any> {
    render() {
        return (
            <>
                {
                    this.props.calendarDeviceMode === CalendarDeviceMode.DESKTOP ? <CalendarModeToggleView {...this.props} /> : null
                }
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: ICalendarViewTogglePropsExternalProps): StateToProps {
    return {
        text: state.calendarText,
        calendarMode: state.calendarSettings.calendarViewMode,
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode,
        currentDate: state.calendar.currentDate,
        startMonth: state.calendar.startDate
    }
}

function jumpToMonth(currentDate: moment.Moment, startDate: moment.Moment) {
    // Don't scroll if loaded month and the start month of Calendar are same
    if (currentDate.month() != startDate.month()) {
        let updateMonth = window.setInterval(() => {
            if (scrollToMonth(currentDate))
                window.clearInterval(updateMonth);
        }, 500);
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToGrid: (currentDate?: moment.Moment, startDate?: moment.Moment) => {
            dispatch(setToGrid())
            if (currentDate != undefined)
                jumpToMonth(currentDate, startDate)
        },
        setToList: (currentDate?: moment.Moment, startDate?: moment.Moment) => {
            dispatch(setToList())
            if (currentDate != undefined)
                jumpToMonth(currentDate, startDate)
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(CalendarViewToggleBase);